import { Navigate, Outlet } from 'react-router-dom';
import { useAuth, type UserRole } from '@/services/auth';
import { hasAnyRole, hasCapability } from '@/services/permissions';

type ProtectedCapabilityRouteProps = {
  allowedRoles?: UserRole[];
  requiredCapabilities?: string[];
  redirectTo?: string;
};

export default function ProtectedCapabilityRoute({
  allowedRoles = [],
  requiredCapabilities = [],
  redirectTo = '/leads',
}: ProtectedCapabilityRouteProps) {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const roleAllowed = allowedRoles.length > 0 && hasAnyRole(user, allowedRoles);
  const capabilityAllowed = requiredCapabilities.some((capability) => hasCapability(user, capability));

  if (!roleAllowed && !capabilityAllowed) {
    return <Navigate to={redirectTo} replace />;
  }

  return <Outlet />;
}
